import {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
} from "@chakra-ui/popover";
import React from "react";

function CustomToolTip(props: any) {
  return (
    <Popover trigger="click" placement="bottom" strategy="fixed">
      <PopoverTrigger>
        <div className="inline-flex items-center">
          {props?.trigger}
        </div>
      </PopoverTrigger>

      <PopoverContent
        border="1px solid #e2e8f0"
        borderRadius="12px"
        boxShadow="0 8px 24px rgba(15,23,42,0.08)"
        bg="white"
        maxW="260px"
        p="0"
        overflow="hidden"
        zIndex="20"
      >
        {props?.header && (
          <PopoverHeader
            fontSize="12px"
            fontWeight="700"
            color="#0f172a"
            borderBottom="1px solid #f1f5f9"
            px="14px"
            py="10px"
          >
            {props.header}
          </PopoverHeader>
        )}

        <PopoverArrow bg="white" />

        <PopoverBody
          className="blh-body"
          fontSize="12px"
          color="#475569"
          px="14px"
          py="12px"
          maxH="50vh"
          overflowY="auto"
        >
          {props?.content}
        </PopoverBody>
      </PopoverContent>
      <style>{`
        .blh-body::-webkit-scrollbar {
          width: 4px;
        }

        .blh-body::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 4px;
        }
      `}
      </style>
    </Popover>
    
  );
}

export default CustomToolTip;